// extracted by css-extract-rspack-plugin
export default {"bui-Flex":"_Zn_QSeBgIX2zuqe"};